import SharedBaseService from './shared.base.service'

class SharedPhotoService extends SharedBaseService{

    async getPhotos(token, jwt) {

        let url = `/api/v1/share/photos/files/${token}`
        const header = {
            'Content-Type': 'application/json',
        }
        if (jwt){
          header['x-token'] = jwt
        }
        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: header,
                credentials: 'same-origin',
            }
        )
        if ( response.ok) {
            const data = await response.json()
            return data.files;
        }
        else if ( response.status == 401) {
            throw Error("401")
        }
    }



}

const sharedPhotoService = new SharedPhotoService();

export default sharedPhotoService;